<script setup lang="ts">
import { BlockScrollCards, HtmlHeadings } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{
  block: BlockScrollCards
}>()

const activeSlide = ref(1)
const isMobile = inject('isMobile')

const increaseSlide = () => {
  if (activeSlide.value < props.block.scrollCards.length - 1) {
    activeSlide.value++
  }
}
const decreesSlide = () => {
  if (activeSlide.value > 1) {
    activeSlide.value--
  }
}

const blockSorted = computed(() => {
  return [...props.block.scrollCards]
    .sort((a, b) => a.id - b.id)
    .map((item, index) => {
      return { ...item, id: index + 1 }
    })
})

const navigateToSlideUrl = async (
  url: string | null | undefined,
  blank: boolean | null | undefined
) => {
  if (url) {
    const options = {
      external: true,
      open: blank ? { target: '_blank' } : undefined,
    }
    await navigateTo(url, options)
  }
}
</script>

<template>
  <section class="mb-8 mt-[41px] flex justify-center">
    <div class="relative w-full md:w-[90%] lg:w-[80%]">
      <SliderCustom
        :slides="isMobile ? 1.5 : 3"
        :space-between="isMobile ? 5 : 25"
        :navigation="!isMobile"
        :navigation-color="block.scrollBtnColor"
        :next-slide="increaseSlide"
        :prev-slide="decreesSlide"
        style="position: initial"
        class="md:w-[85%] lg:w-[75%]"
      >
        <SwiperSlide v-for="slide in blockSorted" :key="slide.id" class="max-w-[280px]">
          <section
            :class="{
              'md:pt-20 lg:mt-10': block.positionCard === 'top',
              'md:mb-20': block.positionCard === 'bottom',
            }"
            class="relative flex cursor-pointer justify-center px-3 pb-5"
            @click="navigateToSlideUrl(slide.url, slide.blank)"
          >
            <figure
              :class="{
                'md:translate-y-0': activeSlide !== slide.id - 1,
                'md:-translate-y-20 ': activeSlide === slide.id - 1 && block.positionCard === 'top',
                'md:translate-y-20 ':
                  activeSlide === slide.id - 1 && block.positionCard === 'bottom',
              }"
              class="relative w-60 rounded-md bg-mcd-secondaryIvory shadow-lg md:transition md:duration-200 md:ease-in-out"
            >
              <img
                class="h-60 w-full rounded-t-md object-contain p-5"
                :src="slide.image.url"
                :alt="slide.image.alternativeText || undefined"
              />
              <div
                class="flex min-h-[7rem] flex-col gap-2 rounded-b-md bg-white px-4 pb-6 pt-4 text-sm leading-4 tracking-[-0.15px]"
              >
                <RenderTitleAs
                  class="font-bold"
                  :text="slide.title"
                  :render-as="block.titleRenderAs || HtmlHeadings.H3"
                />
                <p>{{ slide.subTitle }}</p>
              </div>
            </figure>
          </section>
        </SwiperSlide>
      </SliderCustom>
    </div>
  </section>
</template>
